<div class="input-group" [class]="classDate" style="position: relative;">
    <input #inp type="text" [(ngModel)]="selectedDate" (ngModelChange)="selectedDateChanged($event,inp)" class="form-control" (click)="togglePicker = !togglePicker">
    <button class="input-group-text" type="button" (click)="togglePicker = !togglePicker">
      <i class="feather icon-calendar icon-md text-muted"></i>
    </button>

    <div class="w-100 d-flex justify-content-end">
        <div class="yearMonth-picker" [ngClass]="{'d-none': !togglePicker,'d-block':togglePicker}">
            <div class="row d-flex flex-nowrap justify-content-center align-items-center">
                <div style="max-width: 230px;">
                    <p class="text-center">{{'Start date' |translate}}</p>
                    <div class="year-picker d-flex align-items-center justify-content-center">
                        <div class="row my-2">
                            <div class="col-12">
                                <div class="prev-year" [hidden]="yearRange.from.year <= minValue.getFullYear()" (click)="decrementYear('from')"><i class="mdi" [ngClass]="{' mdi-chevron-left': liveTranslate.currentLang != 'ar',' mdi-chevron-right':liveTranslate.currentLang=='ar'}"></i></div>
                                <div class="shown-year"><span class="">{{yearRange.from.year}}</span></div>
                                <div class="next-year" [hidden]="yearRange.from.year >= maxValue.getFullYear()" (click)="incrementYear('from')"><i class="mdi" [ngClass]="{' mdi-chevron-right': liveTranslate.currentLang != 'ar',' mdi-chevron-left':liveTranslate.currentLang=='ar'}"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="month-picker d-flex align-items-center justify-content-center">
                        <div class="row">
                            <div class="col-4" *ngFor="let m of months">
                                <div class="month" [ngStyle]="{'background-color': shadeSelectedFromDate(m)}">
                                    <div (click)="selectMonth(m.id,'from')" [ngClass]="{'active': yearRange.from.month == m.id,'is-disabled': m.id < minValue.getMonth()}">{{m.subName | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div style="max-width: 230px;">
                    <p class="text-center">{{'End date' |translate}}</p>
                    <div class="year-picker d-flex align-items-center justify-content-center">
                        <div class="row my-2">
                            <div class="col-12">
                                <div class="prev-year" [hidden]="yearRange.to.year <= yearRange.from.year" (click)="decrementYear('to')"><i class="mdi" [ngClass]="{' mdi-chevron-left': liveTranslate.currentLang != 'ar',' mdi-chevron-right':liveTranslate.currentLang=='ar'}"></i></div>
                                <div class="shown-year"><span class="">{{yearRange.to.year}}</span></div>
                                <div class="next-year" [hidden]="yearRange.to.year >= maxValue.getFullYear()" (click)="incrementYear('to')"><i class="mdi" [ngClass]="{' mdi-chevron-right': liveTranslate.currentLang != 'ar',' mdi-chevron-left':liveTranslate.currentLang=='ar'}"></i></div>
                            </div>
                        </div>
                    </div>
                    <div class="month-picker d-flex align-items-center justify-content-center">
                        <div class="row">
                            <div class="col-4" *ngFor="let m of months">
                                <div class="month" [ngStyle]="{'background-color': shadeSelectedToDate(m)}">
                                    <div (click)="selectMonth(m.id,'to')" [ngClass]="{'active':  yearRange.to.month == m.id,'is-disabled': m.id < minValue.getMonth()}">{{m.subName | translate }}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>